import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_EDIT,
	STR_DELETE_CONTACT_WARNING,
	STR_DOWNLOAD_CONTACT_WARNING
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdDelete, MdDownloading, MdInfoOutline, MdMessage, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdWhatsapp } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import CreateContact from '../views/CreateContact';

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	

	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	
	async function deleteContact() {
		setLoading(true);
		await callApi(
			"delete-contact",
			{
				id,
			}
		).then((response) => {
			if(response.status === 1) {
				appContext.tellMessage(STR_SUCCESS[appContext.language]);
				appContext.navBack();
				appContext.getAllContacts();
				appContext.getAllContactGroups();
			} else {
				appContext.tellError(response.msg);
			}
		})
		setLoading(false);
	}
async function handleDownloadContact() {
      setLoading(true);

	try {

    /* Fetch single contact data from API*/
    const response = await callApi("get-contact-data", { id });

    // Validate response
    if (response.status !== 1 || !response.data) {
      appContext.tellError(response.msg );
      return;
    }

    const contactData = response.data;

    /* Prepare CSV for ONE contact*/
    const headers = ["Name", "Phone Number", "WhatsApp Number"];
    const values = [
      contactData.name,
      `="${contactData.phoneNumber}"`, 
      contactData.whatsAppNumber ? `="${contactData.whatsAppNumber}"` : "N/A"
    ];

    const csvContent = `${headers.join(",")}\n${values.join(",")}`;

    /* Create CSV Blob for download*/
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    /* Trigger file download*/
    const link = document.createElement("a");
    link.href = url;
    link.download = `${contactData.name.replace(/\s+/g, "_")}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

	appContext.tellMessage(STR_SUCCESS[appContext.language]);
  } catch (error) {
    
  }
    setLoading(false);
}




	

	async function getData() {
		await callApi(
			"get-contact-data",
			{
				id,
			}
		).then((response) => {
			if(response.status === 1) {
				setData(response.data)
			} 
		})
	}


	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="font-semi-bold"
							style={{
								fontSize: "32px"
							}}
						>
							{data.name}
						</h6>

						<div className="mt-4 d-flex justify-content-end">
						
							<div className="d-flex m-1">
								<MdMessage className="align-self-center" size={24}/>
								<h6
									style={{
										fontSize: "12px",
									}}
									className="font-semi-bold align-self-center mNoMargin"
								>
									{data.phoneNumber}
								</h6>
		
							</div>
		
							<div className="d-flex m-1">
								<MdWhatsapp className="align-self-center" size={24}/>
								<h6
									style={{
										fontSize: "12px",
									}}
									className="font-semi-bold align-self-center mNoMargin"
								>
									{data.whatsAppNumber || "N/A"}
								</h6>
							</div>
		
						</div>

						<div className="mt-4 text-end">
							<button
								className="btn btn-danger"
								onClick={() => {
									appContext.activateDialog({
										message: STR_DELETE_CONTACT_WARNING[appContext.language],
										onConfirm: deleteContact,
									})
								}}
							>
								<MdDelete size={24}/>
							</button>
							<button
  className="btn btn-success ms-2"
 									 onClick={() => {
   										 appContext.activateDialog({
   									     message: STR_DOWNLOAD_CONTACT_WARNING[appContext.language],
     									 onConfirm: () => handleDownloadContact(id),  // Pass id here
  							 		 }	)
 								 }}
							>
  								<MdDownloading size={24}/>
							</button>



						</div>

						<hr/>

					</div>

					<div className="col-md-12">
						<div className="card">
							<div className="card-body">
								<h6 className="card-title">{STR_EDIT[appContext.language]}</h6>
								<CreateContact data={data} callback={getData}/>
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}